<template>
    <div class="container pt-2">
        <PageTitle main="Clientes" sub="Cadastrar, alterar ou deletar Clientes" />
        <b-form>
            <input id="cliente-id" type="hidden" v-model="cliente.id" />
            <div class="row">
                <div class="col-md-10">
                    <b-form-group label="Nome:" label-for="cliente-nome">
                        <b-form-input id="cliente-nome" type="text"
                            v-model="cliente.nome"
                            placeholder="Informe o Nome do cliente."
                            :class="{ 'inputError': $v.cliente.nome.$error }"
                            class="textInput"
                            @keydown.tab="$v.cliente.nome.$touch"/>
                        <span class="error" v-if="!$v.cliente.nome.required && $v.cliente.nome.$error">Campo Obrigatório!</span>
                        <span class="error" v-if="!$v.cliente.nome.minLength && $v.cliente.nome.$error">Precisa ter no mínimo 3 letras!</span>
                    </b-form-group>
                </div>
                <div class="col-md-2">
                    <b-form-group label="Ativo:" label-for="cliente-ativo">
                        <b-form-select id="cliente-ativo" :options="ativar" v-model="cliente.ativo"
                        :class="{ 'inputError': $v.cliente.ativo.$error }"
                        class="textInput"
                        @keydown.tab="$v.cliente.ativo.$touch"
                        />
                        <span class="error" v-if="!$v.cliente.ativo.required && $v.cliente.ativo.$error">Campo Obrigatório!</span>
                    </b-form-group>
                </div>
            </div>
            <div class="row">
                <div class="col-md-4">
                    <b-form-group label="Telefone:" label-for="cliente-telefone">
                        <b-form-input id="cliente-telefone" type="tel"
                            v-model="cliente.telefone" 
                            placeholder="Informe o telefone do cliente."
                            v-mask="['(##)####-####', '(##)#####-####']"
                            :class="{ 'inputError': $v.cliente.telefone.$error }"
                            class="textInput"
                            @keydown.tab="$v.cliente.telefone.$touch"
                            />
                        <span class="error" v-if="!$v.cliente.telefone.required && $v.cliente.telefone.$error">Campo Obrigatório!</span>
                        <span class="error" v-if="!$v.cliente.telefone.minLength && $v.cliente.telefone.$error">Digite o telefone completo com DDD!</span>
                    </b-form-group>
                </div>
                <div class="col-md-6">
                    <b-form-group label="E-mail:" label-for="cliente-email">
                        <b-form-input id="cliente-email" type="email"
                            v-model="cliente.email" 
                            placeholder="Informe o E-mail do cliente."
                            :class="{ 'inputError': $v.cliente.email.$error }"
                            class="textInput"
                            @keydown.tab="$v.cliente.email.$touch"
                            />
                        <span class="error" v-if="!$v.cliente.email.required && $v.cliente.email.$error">Campo Obrigatório!</span>
                        <span class="error" v-if="!$v.cliente.email.email && $v.cliente.email.$error">Digite um email válido!</span>
                    </b-form-group>
                </div>
                <div class="col-md-2">
                    <b-form-group label="CEP:" label-for="cliente-cep">
                        <b-form-input id="cliente-cep" type="text"
                            v-model="cliente.cep" 
                            placeholder="CEP"
                            v-mask="'#####-###'"
                            @keydown.tab="searchCep"
                            :class="{ 'inputError': $v.cliente.cep.$error }"
                            class="textInput"
                            />
                        <span class="error" v-if="!$v.cliente.cep.required && $v.cliente.cep.$error">Campo Obrigatório!</span>
                        <span class="error" v-if="!$v.cliente.cep.minLength && $v.cliente.cep.$error">Digite um CEP completo!</span>
                    </b-form-group>
                </div>
            </div>
            <div class="row">
                <div class="col-md-3">
                    <b-form-group label="Cidade:" label-for="cliente-cidade">
                        <b-form-input id="cliente-cidade" type="text"
                            v-model="cliente.cidade" 
                            placeholder="Informe o Cidade do cliente."
                            :class="{ 'inputError': $v.cliente.cidade.$error }"
                            class="textInput"
                            @keydown.tab="$v.cliente.cidade.$touch"
                            />
                        <span class="error" v-if="!$v.cliente.cidade.required && $v.cliente.cidade.$error">Campo Obrigatório!</span>
                    </b-form-group>
                </div>
                <div class="col-md-2">
                    <b-form-group label="UF:" label-for="cliente-UF">
                        <b-form-select id="cliente-UF" :options="ufs" v-model="cliente.uf"
                        :class="{ 'inputError': $v.cliente.uf.$error }"
                        class="textInput"
                        @keydown.tab="$v.cliente.uf.$touch"
                        />
                        <span class="error" v-if="!$v.cliente.uf.required && $v.cliente.uf.$error">Campo Obrigatório!</span>
                    </b-form-group>
                </div>
                <div class="col-md-4">
                    <b-form-group label="Logradouro:" label-for="cliente-logradouro">
                        <b-form-input id="cliente-logradouro" type="text"
                            v-model="cliente.logradouro" 
                            placeholder="Informe o logradouro do cliente."
                            :class="{ 'inputError': $v.cliente.logradouro.$error }"
                            class="textInput"
                            @keydown.tab="$v.cliente.logradouro.$touch"
                            />
                        <span class="error" v-if="!$v.cliente.logradouro.required && $v.cliente.logradouro.$error">Campo Obrigatório!</span>
                        <span class="error" v-if="!$v.cliente.logradouro.minLength && $v.cliente.logradouro.$error">Precisa ter no mínimo 3 letras!</span>
                    </b-form-group>
                </div>
                <div class="col-md-1">
                    <b-form-group label="Número:" label-for="cliente-numero">
                        <b-form-input id="cliente-numero" type="text"
                            v-model="cliente.numero"
                            placeholder="Nº"
                            :class="{ 'inputError': $v.cliente.numero.$error }"
                            class="textInput"
                            @keydown.tab="$v.cliente.numero.$touch"
                            />
                        <span class="error" v-if="!$v.cliente.numero.required && $v.cliente.numero.$error">Campo Obrigatório!</span>
                    </b-form-group>
                </div>
                <div class="col-md-2">
                    <b-form-group label="Complemento:" label-for="cliente-complemento">
                        <b-form-input id="cliente-complemento" type="text"
                            v-model="cliente.complemento"
                            class="textInput"
                            />
                    </b-form-group>
                </div>
            </div>
            <b-button variant="outline-success" class="botaoInput" @click="save">Salvar</b-button>
            <b-button variant="outline-danger" class="ml-2 botaoInput" @click="reset">Cancelar</b-button>
        </b-form>
        <hr>
        <div :style="{ overflow: overflowValue, width: larguraTela + 'px' }" v-if="larguraTela<721">
            <div class="row mb-3">
                <div class="col-md-7">
                </div>
                <div class="col-md-5">
                    <b-input-group>
                        <b-form-input
                        v-model="filtro"
                        type="search"
                        id="filterInput"
                        class="textInput"
                        placeholder="Pesquisar..."
                        ></b-form-input>
                        <b-input-group-append>
                        <b-button variant="outline-secondary" class="botaoInput" :disabled="!filtro" @click="filtro = ''">Limpar</b-button>
                        </b-input-group-append>
                    </b-input-group>
                </div>
            </div>
            <b-table 
                hover 
                striped 
                id="table-clientes" 
                class="text-center table table-sm" 
                :items="clientes.length>0?clientes:[]" 
                :fields="fields" 
                per-page="5"
                :current-page="currentPage"
                :filter="filtro"
                :filterIncludedFields="filtrando"
                @filtered="onFiltered">
                <template v-slot:cell(actions)="data">
                    <b-button variant="warning" class="mr-2 btn-sm mb-1 btn-size" @click="loadCliente(data.item)">
                        <i class="far fa-edit text-white"></i>
                    </b-button>
                    <b-button variant="danger" class="mr-2 btn-sm mb-1 btn-size" @click="remove(data.item)">
                        <i class="fa fa-trash"></i>
                    </b-button>
                </template>
            </b-table>
            <div class="row" v-if="exibeRodape">
                <div class="col-md-12 text-center mb-3">
                    <span class="text-custom"><i>Não há nenhum dado disponível!</i></span>
                </div>
            </div>
            <div>
                <b-pagination
                size="sm"
                v-model="currentPage"
                :total-rows="rows"
                per-page="5"
                aria-controls="table-clientes"
                first-number
                last-number
                align="center"
                ></b-pagination>
            </div>
        </div>
        <div v-else>
            <div class="row mb-3">
                <div class="col-md-7">
                </div>
                <div class="col-md-5">
                    <b-input-group>
                        <b-form-input
                        v-model="filtro"
                        type="search"
                        id="filterInput"
                        class="textInput"
                        placeholder="Pesquisar..."
                        ></b-form-input>
                        <b-input-group-append>
                        <b-button variant="outline-secondary" class="botaoInput" :disabled="!filtro" @click="filtro = ''">Limpar</b-button>
                        </b-input-group-append>
                    </b-input-group>
                </div>
            </div>
            <b-table 
                hover 
                striped 
                id="table-clientes" 
                class="text-center table table-sm" 
                :items="clientes.length>0?clientes:[]" 
                :fields="fields" 
                per-page="5"
                :current-page="currentPage"
                :filter="filtro"
                :filterIncludedFields="filtrando"
                @filtered="onFiltered">
                <template v-slot:cell(actions)="data">
                    <b-button variant="warning" class="mr-2 btn-sm mb-1 btn-size" @click="loadCliente(data.item)">
                        <i class="far fa-edit text-white"></i>
                    </b-button>
                    <b-button variant="danger" class="mr-2 btn-sm mb-1 btn-size" @click="remove(data.item)">
                        <i class="fa fa-trash"></i>
                    </b-button>
                </template>
            </b-table>
            <div class="row" v-if="exibeRodape">
                <div class="col-md-12 text-center mb-3">
                    <span class="text-custom"><i>Não há nenhum dado disponível!</i></span>
                </div>
            </div>
            <div>
                <b-pagination
                size="sm"
                v-model="currentPage"
                :total-rows="rows"
                per-page="5"
                aria-controls="table-clientes"
                first-number
                last-number
                align="center"
                >
                </b-pagination>
            </div>
        </div>
    </div>
</template>

<script>

import { baseApiUrl } from '@/global'
import axios from 'axios'
import PageTitle from '@/components/template/PageTitle'
import { mask } from 'vue-the-mask'
import { required, minLength, email } from 'vuelidate/lib/validators'
import { VueEasyJwt } from 'vue-easy-jwt'

export default {
    name: 'clientes',
    components: { PageTitle },
    directives: { mask },
    data: function() {
        return {
            exibeRodape: true,
            currentPage: 1,
            filtro: null,
            filtrando: [],
            totalRows: 1,
            jwt: new VueEasyJwt(),
            ativar: [
                { value: '1', text: 'Sim' },
                { value: '0', text: 'Não' }
            ],
            ufs: [
                { value: 'AC', text: 'Acre' },
                { value: 'AL', text: 'Alagoas' },
                { value: 'AP', text: 'Amapa' },
                { value: 'AM', text: 'Amazonas' },
                { value: 'BA', text: 'Bahia' },
                { value: 'CE', text: 'Ceará' },
                { value: 'DF', text: 'Distrito Federal' },
                { value: 'ES', text: 'Espirito Santo' },
                { value: 'GO', text: 'Goiás' },
                { value: 'MA', text: 'Maranhão' },
                { value: 'MT', text: 'Mato Grosso' },
                { value: 'MS', text: 'Mato Grosso do Sul' },
                { value: 'MG', text: 'Minas Gerais' },
                { value: 'PA', text: 'Para' },
                { value: 'PB', text: 'Paraíba' },
                { value: 'PR', text: 'Paraná' },
                { value: 'PE', text: 'Pernambuco' },
                { value: 'PI', text: 'Piauí' },
                { value: 'RJ', text: 'Rio de Janeiro' },
                { value: 'RN', text: 'Rio Grande do Norte' },
                { value: 'RS', text: 'Rio Grande do Sul' },
                { value: 'RO', text: 'Rondônia' },
                { value: 'RR', text: 'Roraima' },
                { value: 'SC', text: 'Santa Catarina' },
                { value: 'SP', text: 'São Paulo' },
                { value: 'SE', text: 'Sergipe' },
                { value: 'TO', text: 'Tocantins' }
            ],
            cliente: {},
            clientes: [],
            fields: [
                { key: 'nome', label: 'Nome', sortable: true, thClass: 'tituloTabela', tdClass: 'fieldsTabela' },
                { key: 'telefone', label: 'Telefone', sortable: true, thClass: 'tituloTabela', tdClass: 'fieldsTabela' },
                { key: 'email', label: 'E-mail', sortable: true, thClass: 'tituloTabela', tdClass: 'fieldsTabela' },
                { key: 'actions', label: 'Ações', thClass: 'tituloTabela', tdClass: 'actionsTabela' }
            ],
            larguraTela: 0,
            overflowValue: 'auto',
            level: '',
            quemRecebeu: '',
            nome: '',
            email: ''
        }
    },
    computed: {
        rows() {
            return this.clientes.length
        }
    },
    validations: {
        cliente: {
            nome: {
                required,
                minLength: minLength(4)
            },
            ativo: {
                required
            },
            telefone: {
                required,
                minLength: minLength(10)
            },
            email: {
                required,
                email
            },
            cep: {
                required,
                minLength: minLength(8)
            },
            cidade: {
                required
            },
            uf: {
                required
            },
            logradouro: {
                required,
                minLength: minLength(4)
            },
            numero: {
                required
            }
        }
    },
    methods: {
        onFiltered(filteredItems) {
            this.totalRows = filteredItems.length
            this.currentPage = 1
        },
        searchCep () {
            this.$v.cliente.cep.$touch()
			if(this.cliente.cep.length == 9) {
				axios.get(`https://viacep.com.br/ws/${ this.cliente.cep }/json/`)
                .then( res => {
                    this.cliente.cidade = res.data.localidade
                    this.cliente.logradouro = res.data.logradouro
                    this.cliente.uf = res.data.uf
                    document.getElementById("cliente-logradouro").value = res.data.logradouro
                    document.getElementById("cliente-UF").value = res.data.uf
                    document.getElementById("cliente-cidade").value = res.data.localidade
                    document.getElementById("cliente-numero").focus()
                })
				.catch( error => console.log(error) )
			} else {
                document.getElementById("cliente-logradouro").value = ''
                document.getElementById("cliente-UF").value = ''
                document.getElementById("cliente-cidade").value = ''
            }
		},
        loadClientes() {
            const url = `${baseApiUrl}/backend/clientes.php`
            axios.get(url).then(res => {
                this.clientes = res.data
                if(this.clientes.length > 0) {
                    this.exibeRodape = false
                }else{
                    this.exibeRodape = true
                }
            })
        },
        reset() {
            this.cliente = {}
            this.loadClientes()
            this.cliente.cidade = ''
            this.cliente.logradouro = ''
            this.cliente.uf = ''
            document.getElementById("cliente-logradouro").value = ''
            document.getElementById("cliente-UF").value = ''
            document.getElementById("cliente-cidade").value = ''
            this.$v.cliente.$reset()
        },
        save() {
            this.$v.cliente.$touch()
            if(!this.$v.cliente.$error){
                const method = this.cliente.id ? 'put' : 'post'
                const id = this.cliente.id ? `?id=${this.cliente.id}` : ''
                this.cliente.senha = '1234'
                axios[method](`${baseApiUrl}/backend/clientes.php${id}`, this.cliente)
                    .then(() => {
                        if (method == 'post'){
                            
                            // const tipo = `?tipo=novoCliente`
                            // const destinoEmail = `&destinoEmail=${this.email}`
                            // const destinoNome = `&destinoNome=${this.nome}`
                            // axios.get(`${baseApiUrl}/backend/mailCliente.php${tipo}${destinoEmail}${destinoNome}`).then({})

                            this.$toasted.global.defaultSuccess({ message : 'Cliente inserido com sucesso!' })
                        } else {

                            // const tipo = `?tipo=alteraCliente`
                            // const destinoEmail = `&destinoEmail=${this.email}`
                            // const destinoNome = `&destinoNome=${this.nome}`
                            // axios.get(`${baseApiUrl}/backend/mailCliente.php${tipo}${destinoEmail}${destinoNome}`).then({})

                            this.$toasted.global.defaultSuccess({ message : 'Cliente alterado com sucesso!' })
                        }
                        this.reset()
                    })
                    .catch(
                        (e) => {
                        this.$toasted.global.defaultError({ message : e.response.data['dados'] })
                    }
                    )
            } else {
                this.$toasted.global.defaultError({ message : 'Verifique os campos!' })
            }
        },
        remove(cliente) {
            const sure = confirm("Deseja realmente excluir o cliente?")
            if(sure === true){
                const url = `${baseApiUrl}/backend/clientes.php`
                axios.delete(url, { data: cliente })
                    .then(() => {
                        this.$toasted.global.defaultSuccess({ message : 'Cliente excluído com sucesso!' })
                        this.reset()
                    })
                    .catch(
                        (e) => {
                        this.$toasted.global.defaultError({ message : e.response.data['dados'] })
                    }
                    )
            }
        },
        loadCliente(cliente) {
            this.cliente = { ...cliente }
        },
        validaLogin() {
            const local = localStorage.getItem('__SYSTEM_USER')
            const decodedToken = this.jwt.decodeToken(local)
            if (local === null) {
                this.$router.push({ path: '/login' })
            } else {
                this.level = decodedToken['data'].level
                this.quemRecebeu = decodedToken['data'].id
                this.nome = decodedToken['data'].nome
                this.email = decodedToken['data'].email
            }
        }
    },
    mounted() {
        this.validaLogin()
        if (this.level === 'cliente') {
            this.$router.push('/')
        }
        this.loadClientes()
        this.larguraTela = screen.width - (screen.width * 0.08)
        this.totalRows = this.clientes.length
    }
}
</script>

<style>
    
</style>